export default __webpack_public_path__ + "static/media/FontAwesome5_Pro_Solid.9d66064f.ttf";